import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import * as _ from "lodash";
import { FormBuilder } from "../../builder";
import { ReviewForm } from "./ReviewForm";
import style from "./style";
import { ToolInfo } from "../../../../../../components/Toolkit/Tool/Type/Layout";
import { ITool } from "../../../interface/ITool";
import { UIOutlineButton } from "../../../../../Buttons";
import AddIcon from "@material-ui/icons/Add";
import { UI_BTN_ACTIONS } from "../../../../config";
import { EditForm } from "../../../helper/Forms/EditForm";
import { IconTrash } from "../../../../../Icons";
import { FileCopyOutlined } from "@material-ui/icons";

// Create styles
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));
const editForm: EditForm = new EditForm();

type props = {
  tool: ITool;
  onChange: any;
  onSubmit: any;
  onValidateForms: any;
  handleNextBack: any;
  handleReset: any;
  activeStep: number;
  handleNewForm: any;
  goToStep: any;
  handleBackButton: any;
  loading: boolean;
  ishavingParent: any;
};

export const StepperForm = (props: props): JSX.Element => {
  const {
    tool,
    onChange,
    onValidateForms,
    handleNextBack,
    handleReset,
    activeStep,
    onSubmit,
    handleNewForm,
    goToStep,
    handleBackButton,
    loading,
    ishavingParent
  } = props;
  const classes = useStyles();

  const propsToToolInfo = {
    data: { ...tool },
  };
  const Forms = tool.forms;
  let nextButtonCount=activeStep;
  let disabledBackButton = _.isEqual(activeStep, 0);
  const isMultiFormAvailable = Forms.filter(form => !_.isEqual(form.id % 1,0));
  const isCLone = tool.is_clone;


  const isButtonDisabled = (): boolean => {
    return !Forms[activeStep]?.isValid 
    || isMultiFormAvailable && editForm.isValidMultiForms(Forms)
    || Forms[activeStep].loading;
  };

  const buildForm = (step: any): any => {
    return <FormBuilder
      form={Forms[step]}
      onValidateForms={onValidateForms}
      onChange={onChange}
      loading={loading}
      ishavingParent={ishavingParent}
      isCLone={isCLone}
    />;
  };


  const multiFormDisplay = (currentStep:any): any => {
    const showAddOption = editForm.showAddForm(Forms);
    const maxDisplayOrder = _.maxBy(Forms, "display_order")?.display_order;
    const count  = _.filter(Forms,{isMultiCountFlag:true}).length;
    const showAddButton = showAddOption && _.lt(Number(count) , Number(tool?.multiset_Form_Limit)) 
                          && !_.isEqual(currentStep, (Forms.length - 2))
                          && _.isEqual(maxDisplayOrder,Forms[currentStep].display_order);
    const showRemoveBtn = showAddOption && !_.isEqual(currentStep, 1) && !_.isEqual(currentStep % 2, 0);

    return (
      <>
      {showRemoveBtn &&
              <div className={classes.additionalFormLine}></div>
            }
        <div className={classes.toolContent}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            
            {showRemoveBtn &&
              _.gt(Forms.filter(x => x.id.toString().startsWith(Forms[activeStep].id.toString())).length, 1) &&
              <div className={classes.deleteButtonContainer}>
                <div className={classes.deleteButtonWrapper}
                  onClick={() => {
                    const DynamicElement = {
                      formId: Forms[currentStep].id, dynamicElement: { action: UI_BTN_ACTIONS.DELETE }
                    };
                    nextButtonCount = nextButtonCount - 2;
                    return onChange(DynamicElement);
                  }}>
                  <div className={classes.deleteButton}>
                  <IconTrash
                    title=""
                    disabled={false}
                    onClick={() => { }}
                  />
                    {`Delete ${Forms[activeStep].title}`}
                  </div>
                </div>
              </div>
            }
          </div>
          {buildForm(currentStep)}
          { showAddButton &&
            <div >
              <div className={classes.addButtonWrapper}>
                <div className={classes.addButton}
                  onClick={() => {
                    const DynamicElement = {
                      formId: Forms[activeStep].id, dynamicElement: { action: UI_BTN_ACTIONS.ADD, isClone: false }
                    };
                    return onChange(DynamicElement);
                  }}
                >
                  <AddIcon className={classes.addButtonIcon} /><span> {`Add ${Forms[activeStep].title}`}</span>&nbsp;
                </div>
                { _.isEqual(isCLone,1) && <div className={classes.addButton}
                  onClick={() => {
                    const DynamicElement = {
                      formId: Forms[activeStep].id, dynamicElement: { action: UI_BTN_ACTIONS.ADD, isClone: true }
                    };
                    return onChange(DynamicElement);
                  }}
                >&nbsp;
                  &nbsp;<FileCopyOutlined className={classes.cloneButtonIcon} /> <span> {`Clone ${Forms[activeStep].title}`}</span>
                </div>}
              </div>
            </div>
            }
        </div>
      </>
    );
  };

  const buttonToDisplay = (currentStep:any,submitBtnText:string):any=>{
    return (
      <>
                  {_.isEqual(currentStep , (Forms.length -1)) &&<div className={classes.nextBackContent}>
                <div>
                  <UIOutlineButton
                    cssStyle={{
                      marginRight: "0.75rem",
                    }}
                    disabled={disabledBackButton}
                    isOutline={true}
                    onClick={() => handleNextBack(activeStep - 2)}
                    btnText="Back"
                  />
                  {_.isEqual(activeStep, Forms.length) ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        onSubmit(tool.forms, (isError: boolean) => {
                          if (isError) {
                            return;
                          }
                          return handleNextBack(2);
                        })
                      }
                      className={classes.button}
                    >
                      Submit
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleNextBack(nextButtonCount + 1)}
                      className={classes.button}
                      disabled={isButtonDisabled()}
                    >
                      {submitBtnText}
                    </Button>
                  )}
                  <UIOutlineButton
                    cssStyle={{
                      marginLeft: 4,
                    }}
                    isOutline={true}
                    onClick={() => {
                      handleBackButton({
                        action: "Cancel",
                      });
                    }}
                    btnText="Cancel"
                  />
                </div>
              
            </div>}
      </>
    );
  };

  const buildFormForMulti = (currentStep: any, submitBtnText:any,flag:boolean): any =>{
    return (
      <>
        <Grid container item direction="column" xs={12}
          sm={12}
          md={8}
          lg={8}
          xl={8}>
          <Grid item className={classes.infoWrapper} key={currentStep}>
            {multiFormDisplay(currentStep)}
            {buttonToDisplay(currentStep,submitBtnText)}
          </Grid>
          {flag && <Grid item className={classes.infoWrapper}>
             {multiFormDisplay(currentStep+1)}
             {buttonToDisplay(currentStep+1,submitBtnText)}
            </Grid>}
        </Grid>
      </>
    );
  };

  const getToolInfo = (): any => {
    return (<Grid
      container
      item
      xs={12}
      sm={12}
      md={4}
      lg={4}
      xl={4}
      justifyContent="center"
      className={classes.infoWrapper}
    >
      <ToolInfo {...propsToToolInfo} />
    </Grid>);
  };

  if (_.lt(activeStep, Forms.length)) {
    disabledBackButton = disabledBackButton || Forms[activeStep].loading;
  }
  let formData;
  if (_.isEqual(activeStep, Forms.length + 1)) {
    formData = (
      <div className={classes.toolContent}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleNewForm();
            return handleReset();
          }}
        >
          New Form
        </Button>
        <UIOutlineButton
          cssStyle={{
            marginLeft: "0.75rem",
          }}
          isOutline={true}
          onClick={() => {
            handleBackButton({
              action: "Go back",
            });
          }}
          btnText="Go back"
        />
      </div>
    );
  } else {
    let formStep;
    if (_.isEqual(activeStep, Forms.length)) {
      formStep = <ReviewForm forms={Forms} goToStep={goToStep} />;
    } else {
      if(!Forms[activeStep]?.isMulti){
      formStep = (
        buildForm(activeStep)
      );
      }
    }
    let submitBtnTxt:any;
    if (_.isEqual(activeStep, Forms.length)) {
      submitBtnTxt = "Submit";
    } else {
      submitBtnTxt = "Next";
    }

    if(Forms[activeStep]?.isMulti){
      //To check more than 2 forms are added in current stepper
      const isMultiFormEnabled = _.gt(Forms.filter(x => x.id.toString().startsWith(Forms[activeStep].id.toString())).length,1);
      formData = (
        <>
          {buildFormForMulti(activeStep, submitBtnTxt,true)}
          {getToolInfo()}

          {isMultiFormEnabled && 
            _.orderBy(Forms,["display_order"],["asc"]) && 
            Forms.map(function (y, index) {
              if (!_.isEqual(y.id % 1 , 0)) {
                nextButtonCount = nextButtonCount+1;
                return buildFormForMulti(index, submitBtnTxt,false);
              }
            })
          }
        </>
      );
    }else{
    formData = (
      <Grid
            container
            item
            xs={12}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            className={classes.infoWrapper}
          >
      <div className={classes.toolContent}>
        {formStep}

        <div>
          <UIOutlineButton
            cssStyle={{
              marginRight: "0.75rem",
            }}
            disabled={disabledBackButton}
            isOutline={true}
            onClick={() => {
              if(tool.forms[tool.forms.length -1].parentId){
                return handleNextBack(- (nextButtonCount - 1));
              }else{
              handleNextBack(-1);}}}
            btnText="Back"
          />
          {_.isEqual(activeStep, Forms.length) ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                onSubmit(tool.forms, (isError: boolean) => {
                  if (isError) {
                    return;
                  }
                  return handleNextBack(1);
                })
              }
              className={classes.button}
            >
              Submit
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => { 
                handleNextBack(1);
                if(_.isEmpty(tool.defaultForms)){
                  tool.defaultForms = tool.forms;
                }
              }}
              className={classes.button}
              disabled={!Forms[activeStep].isValid || Forms[activeStep].loading}
            >
              {submitBtnTxt}
            </Button>
          )}
          <UIOutlineButton
            cssStyle={{
              marginLeft: 4,
            }}
            isOutline={true}
            onClick={() => {
              handleBackButton({
                action: "Cancel",
              });
            }}
            btnText="Cancel"
          />
        </div>
      </div>
      </Grid>
    );
          }
  }
  
  return (
    <Grid container className={classes.toolContentWrapper}>
        <>
          {formData}
          {/* Avoiding toolInfo for multiForm because it is already rendred inside isMulti check  */}
          {!Forms[activeStep]?.isMulti && getToolInfo()}
        </>

    </Grid>
  );
};
